export const FeatureName: string = 'alfrescoDocuments';
